import desktop from "../assets/images/new_bp_form_desktop.webp";
import mobile from "../assets/images/new_bp_form_mobile.webp";
import Header from "./Header";
import "./ThankYouPage.scss";

export default function ThankYouPage() {
    return (
        <>
            <Header/>
            <div className="main-container row-layout-template thx-page">
                <div className="form-outer-container form-outer-container--message">
                    <div className="form-bg">
                        <div className="form-container">
                            <div className="form-triangle-decor"/>
                            <div className="form-row">
                                <div className="form-copy">
                                    <h1>ZOSTAŁ OSTATNI KROK!</h1>
                                    <p>Wysłaliśmy do Ciebie e-mail z prośbą o potwierdzenie chęci zapisu. Kliknij przycisk w wiadomości, aby potwierdzić.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="main-image">
                    <img src={desktop} className="background-image" alt=""/>
                    <img src={mobile} className="background-image-mobile" alt=""/>
                </div>
            </div>
        </>
    );
}
